import script from "./ProfileMatchesPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileMatchesPage.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileMatchesPage.vue?vue&type=style&index=0&id=1991dbeb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1991dbeb"]])

export default __exports__